import { isNode } from "react-flow-renderer";
import { VERBS } from "./verbs";

// Detecta o que ainda falta configurar num fluxo (auto "primeiros passos"):
//   - campos OBRIGATÓRIOS vazios (required: true em verbs.js);
//   - valores com MARCADOR a substituir (texto entre < >, ex.: <SUA-URL>).
// Retorna [{ nodeId, node, field, message }] — clicável para focar o nó.
// marcadores a substituir: <...>, ou valores de exemplo comuns de template
// (exemplo/example/SUA-/SEU-/cole-aqui/sua-agenda...).
const PLACEHOLDER = /<[^>]{2,}>|\bexemplo\b|\bexample\b|\bSUA[-_ ]|\bSEU[-_ ]|cole[-_ ]aqui/i;

export const detectPending = elements => {
  const out = [];
  (elements || []).forEach(el => {
    if (!isNode(el) || !el.data || el.data.verbKey === "__trigger__" || el.data.verbKey === "__start__") return;
    const def = VERBS[el.data.verbKey];
    if (!def || !def.fields) return;
    def.fields.forEach(f => {
      const v = (el.data || {})[f.name];
      const empty = v == null || v === "" || (Array.isArray(v) && v.length === 0);
      if (f.required && empty) {
        out.push({ nodeId: el.id, node: def.title, field: f.label, message: `Configure "${f.label}" em "${def.title}"` });
      } else if (typeof v === "string" && PLACEHOLDER.test(v)) {
        out.push({ nodeId: el.id, node: def.title, field: f.label, message: `Substitua o marcador em "${f.label}" (${def.title})` });
      }
    });
  });
  return out;
};
